/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import cn from 'classnames';
import he from 'he';
import Image from 'next/image';
import React, { forwardRef, useCallback } from 'react';

import { ENV } from '@shared/config';
import { parseMusicians } from '@shared/libs';
import type { Locale } from '@shared/libs';
import { MusicInfo, NotesCardQueryData } from '@shared/types';
import { H2, stylesButton } from '@shared/ui';

import bg2 from './bg-2.png';
import bg from './bg.png';

import styles from './download-preview.module.css';

interface props {
  musicians?: MusicInfo[];
  title: string;
  locale: Locale;
  orderId: number;
  data: NotesCardQueryData['data'];
}

const DownloadPreview = forwardRef<HTMLDivElement | null, props>(
  ({ title, musicians, locale, orderId, data }, ref) => {
    const handleDownloadPreview = useCallback(() => {
      // Log the error to an error reporting service
      if (process.env.NODE_ENV !== 'development') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.ym?.(Number(process.env.NEXT_PUBLIC_YA_METRIKA), 'reachGoal', 'DOWNLOAD_PREVIEW');
      }
    }, []);

    return (
      <div className={styles.container} ref={ref}>
        <H2 className={styles.title}>{data.DOWNLOAD_PREVIEW_PDF_BANNER_TITLE_BACK}</H2>
        <div className={styles.text}>
          {he.decode(locale.DOWNLOAD_PREVIEW_TEXT_FRAGMENT_1 || 'DOWNLOAD_PREVIEW_TEXT_FRAGMENT_1')}{' '}
          {parseMusicians(musicians)} - {title}{' '}
          {he.decode(locale.DOWNLOAD_PREVIEW_TEXT_FRAGMENT_2 || 'DOWNLOAD_PREVIEW_TEXT_FRAGMENT_2')}
          <br />
          <br />
          {he.decode(locale.DOWNLOAD_PREVIEW_TEXT_FRAGMENT_3 || 'DOWNLOAD_PREVIEW_TEXT_FRAGMENT_3')}
        </div>
        <a
          title={title}
          href={`${ENV.API}/preview_pdf_download/${orderId}/`}
          download
          target="_blank"
          className={cn(stylesButton.button, stylesButton.black, styles.btn)}
          onClick={handleDownloadPreview}
        >
          <span>{data.DOWNLOAD_PREVIEW_PDF_BANNER_BTN_BACK}</span>
        </a>
        <Image className={styles.bg} src={bg} alt="bg" />
        <Image className={styles.bg2} src={bg2} alt="bg2" />
      </div>
    );
  },
);

DownloadPreview.displayName = 'downloadPreview';

export default DownloadPreview;
